import axios from "axios";

const basePath = window.laravel.hostWithScheme + '/api';

const ApiService = {
    get(path, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(basePath + path, {params})
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    post(path, data = {}) {
        return new Promise((resolve, reject) => {
            axios.post(basePath + path, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    update(path, data) {
        return new Promise((resolve, reject) => {
            axios.post(basePath + path, {...data, ...{_method: 'PUT'}})
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    delete(path) {
        return new Promise((resolve, reject) => {
            axios.delete(basePath + path)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    download(path, params = {}) {
        return new Promise((resolve, reject) => {
            axios({
                url: basePath + path,
                method: 'GET',
                responseType: 'blob',
                params,
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1].replace(/\"/g,""));
                document.body.appendChild(link);
                link.click();

                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    downloadPost(path, params = {}) {
        return new Promise((resolve, reject) => {
            axios({
                url: basePath + path,
                method: 'POST',
                responseType: 'blob',
                data: params,
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1].replace(/\"/g,""));
                document.body.appendChild(link);
                link.click();

                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    infoCurrentIp() {
        return fetch('https://ipinfo.io/json')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed request');
                }

                return response.json();
            });
    }
};

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 500 && error.response.data.message === 'Technical error') {
        window.location.href = '/technical';
    }

    return Promise.reject(error);
});

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.xsrfCookieName = window.laravel.csrfTokenName;
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

export default ApiService;
